import { Model, createRecipe } from 'algu-domain'

import { configuratorInterface } from '../configurator-interface.js'
import { ALL_VIOLATIONS } from './all-violations.js'

// These need to support all types of top material
export const DEFAULT_LEG_TYPE_ROUND = Model.Legs3DRonde.type
export const DEFAULT_LEG_TYPE_OTHER = Model.Legs3D.type

/**
 * A user should always be able to select a different shape for their table top. Because most
 * of the leg styles are only available for _either_ round or other shapes, when changing to
 * and from a round table, the leg style needs to be changed, which means a second domain
 * entity replacement is needed.
 */
export const fixLegsForCircleTop = configuratorInterface.transformerBuilder.when
  .entity(['TopCircle'])
  .replaces(Model.Top.types)
  .causes.entity(Model.AnyDomainEntity.types)
  .violation(ALL_VIOLATIONS)
  .then.applySideEffect(ctx => {
    const idSequence = ctx.getIdSequence()
    const currentLegs = ctx.getOld$Root().$legs
    const recipe = createRecipe({ type: DEFAULT_LEG_TYPE_ROUND })
    return [
      configuratorInterface.updates.DomainEntityReplacement({
        entityId: currentLegs.id as any, // typing issue in the SDK - will fix later
        replacementEntity: {
          ...recipe,
          id: idSequence.nextId(DEFAULT_LEG_TYPE_ROUND),
        },
        keepChildren: false,
        updateTag: 'fixTableLegs.changeTopShape',
      }),
    ]
  })
  .build('Fix table legs for circle top shape update')

export const fixLegsForNonCircleTop = configuratorInterface.transformerBuilder.when
  .entity(Model.Top.types)
  .replaces(['TopCircle'])
  .causes.entity(Model.AnyDomainEntity.types)
  .violation(ALL_VIOLATIONS)
  .then.applySideEffect(ctx => {
    const idSequence = ctx.getIdSequence()
    const currentLegs = ctx.getOld$Root().$legs
    const recipe = createRecipe({ type: DEFAULT_LEG_TYPE_OTHER })
    return [
      configuratorInterface.updates.DomainEntityReplacement({
        entityId: currentLegs.id as any,
        replacementEntity: {
          ...recipe,
          id: idSequence.nextId(DEFAULT_LEG_TYPE_OTHER),
        },
        keepChildren: false,
        updateTag: 'fixTableLegs.changeTopShape',
      }),
    ]
  })
  .build('Fix table legs for non-circle top shape update')
